export default {
  have_account: 'Heb je een account?',
  sign_in: 'Inloggen',
  sign_in_description: 'om je punten en opgeslagen gegevens te gebruiken',
  join_free: 'Gratis aanmelden',
  join_description: '— verdien beloningen bij elke bestelling',
  join_description_with_discount: `— verdien beloningen zoals tot <highlight>{{max_discount}} korting</highlight> per bestelling`,
  join_description_with_product_and_discount: `— verdien beloningen zoals gratis {{product_name}} & tot <highlight>{{max_discount}} korting</highlight> per bestelling`,
  demo_mode: 'Demomodus',
};
